import EnterpricePage from './EnterpricePage';

export default EnterpricePage;
